import { z } from 'zod';
import { pageEntrySchema } from './PageEntry.js';

const iArkEntryDataSchema = z.object({
  userId: z.string().optional(),
  version: z.number().default(2),
  originalVersion: z.number().default(1),
  shared: z.boolean().default(false),
  currentPageId: z.string().optional(),
  pages: z.array(pageEntrySchema).default([])
});

export { iArkEntryDataSchema };
//# sourceMappingURL=ComponentEntry.js.map
